import { Button, Icon, Menu, MenuPlacement } from '@shinetools/lumen-react'
import { Download } from 'lucide-react'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import type { ReportExportFormat } from '../../types/reportExport'

export const REPORT_EXPORT_FORMATS: ReportExportFormat[] = ['pdf', 'xlsx']

const EXPORT_FORMAT_LABEL_KEY: Record<ReportExportFormat, string> = {
  pdf: 'expert_reports.export.pdf',
  xlsx: 'expert_reports.export.xlsx',
}

interface ExportMenuProps {
  isExporting: boolean
  onOpen?: () => void
  onSelectFormat: (format: ReportExportFormat) => void
}

export const ExportMenu = ({ isExporting, onOpen, onSelectFormat }: ExportMenuProps): ReactElement => {
  const { t } = useTranslation()

  const handleSelect = useCallback(
    (format: ReportExportFormat) => () => {
      onSelectFormat(format)
    },
    [onSelectFormat],
  )

  const handleOpenChange = useCallback(
    (isOpen: boolean) => {
      if (isOpen) {
        onOpen?.()
      }
    },
    [onOpen],
  )

  return (
    <Menu
      aria-label={t('expert_reports.export.label')}
      onOpenChange={onOpen ? handleOpenChange : undefined}
      placement={MenuPlacement['bottom-end']}
      trigger={
        <Button
          label={t('expert_reports.export.label')}
          loading={isExporting}
          startIcon={<Icon icon={Download} />}
          variant="outlined"
        />
      }
    >
      {REPORT_EXPORT_FORMATS.map((format) => (
        <Menu.Item key={format} label={t(EXPORT_FORMAT_LABEL_KEY[format])} onClick={handleSelect(format)} />
      ))}
    </Menu>
  )
}
